import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@modules/auth/_services/auth.guard';
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email.component';
import { AuthAndOnboardedGuard } from '@modules/auth/_services/auth-and-onboarded.guard';

// TODO: replace all loadChildren with dynamic esm import statements

export const routes: Routes = [
  {
    path: 'api/account/confirm-email',
    component: ConfirmEmailComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard],
    loadChildren: () =>
    import('./modules/onboarding/onboarding.module').then(m => m.OnboardingModule)
  },
  {
    path: '',
    canActivate: [AuthAndOnboardedGuard],
    loadChildren: () =>
      import('./pages/layout.module').then(m => m.LayoutModule),
  },
  {path: '**', redirectTo: 'error/404'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
